import ProhibitedItemImport from '../../components/layout/ITHeadquarters/prohibitedItemImport';

const ExceptionItemImportPage = () => {
    return <ProhibitedItemImport isException />;
};
export default ExceptionItemImportPage;
